export class ConsoleModal {
    isOpen: boolean;
    title: string;

    constructor(isOpen: boolean, title: string) {
        this.isOpen = isOpen;
        this.title = title;
    }
}